<template>
  <section class="dbData" :id="dbName+'Data'" role="tabpanel" :aria-labelledby="dbName+'Tab'" :aria-expanded="[isFirst ? 'true' : 'false']">
    <div class="infoArea">
      <galleryCarousel v-if="images" :images="images" @parentFunc="openZoomModal"></galleryCarousel>
      <div class="detail">
        <ul class="linkItemList">
          <template v-for="(record, index) in records">
            <li :key="index"><a class="g-btn g-btn-sm" @click="setActiveDesc(index)" :aria-selected="isActiveDesc == index ? true : false">{{ record.title }}</a></li>
          </template>
        </ul>
        <template v-for="(record, index) in records">
          <table v-if="isActiveDesc == index" class="detail_data" :key="index">
            <tr v-for="(value, name, index) in record.fields" :key="index">
              <th>{{ name }}</th>
              <td v-html="join(value)"></td>
            </tr>
          </table>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from '@/i18n.js'
import galleryCarousel from '@/components/galleryCarousel.vue'

export default {
  components: {
    galleryCarousel
  },
  props: {
    dbName: { type: String, required: true },
    records: { type: Array, required: true },
    images: { type: Array, required: true },
    isFirst: { type: Boolean, required: true },
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
          nextEl: '.gallery_carousel_next',
          prevEl: '.gallery_carousel_prev'
        }
      },
      isActiveDesc: 1
    }
  },
  filters: {
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  methods: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    // タブパネルの切り替え用
    setActiveDesc(val) {
      this.isActiveDesc = val
    },
    openZoomModal(target) {
      this.$emit('parentFunc', target)
    },
  }
}
</script>
